import { type ReactNode } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import {
  renderItems
} from "~/features/selectionAssistant/bearing/components/Filters/TechFilters/DesktopTechFilterCategory";
import { useTranslation } from "react-i18next";
import { Button, styled } from "~/common/mui";
import type { TechFilter } from "~/features/search/models/filterConfigModels";
import { useTechFilterReset } from "~/features/search/components/Filters/TechFilterResetContext";

const MobileCategory = styled("div")(({ theme }) => ({
  "& > * + *": {
    marginTop: theme.spacing(2),
  },
}));

const MobileActions = styled("div")(({ theme }) => ({
  display: "flex",
  "& > *": {
    flex: "1 0 0",
  },
  "& > * + *": {
    marginLeft: theme.spacing(2),
  },
}));

interface Props {
  image?: ReactNode;
  items: TechFilter[];
}

export const MobileTechFilterCategory = (props: Props) => {
  const { items, image } = props;
  const { t } = useTranslation();
  const { control } = useFormContext();
  const { resetFilters } = useTechFilterReset();

  const techFilterCodes = items.map((item) => item.uid);

  // Watch values to determine if buttons should be enabled
  const allValues = useWatch({ control });
  const isClearEnabled = techFilterCodes.some(
    (uid) => allValues[uid]?.["min"] !== undefined || allValues[uid]?.["max"] !== undefined,
  );

  const { formState } = useFormContext();
  const isApplyEnabled = formState.isDirty;

  const onClearClick = () => {
    resetFilters(techFilterCodes);
  };

  const renderChildren = renderItems(items);

  return (
    <MobileCategory>
      {image}
      {renderChildren}
      <MobileActions>
        <Button disabled={!isClearEnabled} onClick={onClearClick} variant={"text"}>
          {t("searchPage.refinement.button.clear")}
        </Button>
        <Button disabled={!isApplyEnabled} type={"submit"}>
          {t("searchPage.refinement.button.apply")}
        </Button>
      </MobileActions>
    </MobileCategory>
  );
};
